import React from 'react';
import PropTypes from 'prop-types';

import { LoaderAnim } from '@sm360/widget-commons-basic-components';

import 'commons-general/components/LoaderFullScreen/LoaderFullScreen.scss';

const LoaderFullScreen = ({ message, show, children }) => {
    const loaderMessage = show ? (
        <div className="LoaderFullScreen__background">
            <div className="LoaderFullScreen__foreground">
                <div className="LoaderFullScreen__message">
                    {message}
                    <LoaderAnim />
                </div>
            </div>
        </div>
    ) : null;

    return (
        <div>
            {loaderMessage}
            <div className="LoaderFullScreen__contentChild">{children}</div>
        </div>
    );
};

LoaderFullScreen.propTypes = {
    message: PropTypes.string,
    show: PropTypes.bool,
    children: PropTypes.element,
};

LoaderFullScreen.defaultProps = {
    message: '',
    show: false,
    children: null,
};

LoaderFullScreen.displayName = 'LoaderFullScreen';
export default LoaderFullScreen;
